import $ from 'jquery';

const sectionContact = () => {
    const init = () => {
        setMapHeight();
    }

    const setMapHeight = () => {
        const el = {
            container: '.col.map',
            map: '.elementor-widget-html iframe',
            otherDetails: '.elementor-inner-section',
        }

        if($(el.container).length === 0 || $(window).width() < 768) return;

        $(window).on('load resize', () => {
            const parent = $(el.container);
            const parentHeight = parent.css('height');
            const otherDetailsHeight = parent.find(el.otherDetails).css('height');

            parent.find(el.map).css('height', `calc(${parentHeight} - ${otherDetailsHeight})`)
        });
    }

    init();
}

export default sectionContact;